import { NotFoundPage } from 'pageModules/NotFoundPage';

export default NotFoundPage;
